<template>
    <div class="container d-flex justify-content-center align-items-center min-vh-100">
        <div class="card shadow p-4" style="width: 350px;">
            <div class="text-center mb-3">
                <img :src="logoUrl" alt="Company Logo" class="img-fluid" style="max-height: 60px;" />
            </div>
            <h3 class="text-center mb-3">TradeLite Login</h3>
            <form @submit.prevent="login">
                <div class="mb-3">
                    <input v-model="email" class="form-control my-2" placeholder="Email Address" required />
                </div>
                <div class="mb-3">
                    <input v-model="password" type="password" class="form-control my-2" placeholder="Password" required />
                </div>
                <button class="btn btn-primary w-100 mb-2" type="submit" :disabled="loading">
                    <output v-if="loading" class="spinner-border spinner-border-sm" aria-hidden="true"></output>
                    Log In
                </button>
            </form>
            <div class="text-center">
                <a href="#" class="text-decoration-none" @click.prevent="forgotPassword">Forgot Password?</a>
            </div>
        </div>
    </div>
</template>

<script>
import { jwtDecode } from 'jwt-decode';
import api from '@/api';
import eventBus from "@/utils/eventBus";
import { triggerMFA } from '@/utils/auth';

export default {
    data() {
        return {
            logoUrl: process.env.VUE_APP_LOGO_URL,
            email: '',
            password: '',
            loading: false
        };
    },
    methods: {
        async login() {
            this.loading = true;
            try {
                const response = await api.post('/v1/auth/authenticate', {
                    username: this.email,
                    password: this.password
                });

                if (response.status === 200) {
                    const { accessToken, refreshToken } = response.data.data;
                    const decoded = jwtDecode(accessToken);

                    localStorage.setItem('accessToken', accessToken);
                    localStorage.setItem('refreshToken', refreshToken);

                    localStorage.setItem('firstName', decoded.firstName);
                    localStorage.setItem('lastName', decoded.lastName);

                    if (decoded.mfaRequired) {
                        localStorage.setItem('mfaVerified', false);
                        await triggerMFA();
                        this.$router.push('/verification');
                    } else {
                        localStorage.setItem('mfaVerified', true);
                        this.$router.push('/dashboard');
                        eventBus.emit('show-alert', {
                            message: 'You have logged in successfully.',
                            type: 'success'
                        });
                    }
                } else {
                    eventBus.emit('show-alert', {
                        message: response.data.message,
                        type: 'danger'
                    });
                }
            } catch (error) {
                console.error(error);

                if (error.response) {
                    console.error(error.response.data);
                    eventBus.emit('show-alert', { message: error.response.data.message, type: 'danger' });
                } else if (error.request) {
                    console.error(error.request);
                    eventBus.emit('show-alert', {
                        message: 'Something went wrong. Contact your administrator.',
                        type: 'danger'
                    });
                } else {
                    eventBus.emit('show-alert', {
                        message: 'Something went wrong. Contact your administrator.',
                        type: 'danger'
                    });
                }

                this.email = '';
                this.password = '';
            } finally {
                this.loading = false;
            }
        },
        async forgotPassword() {
            this.loading = true;
            this.$router.push('/forgot-password');
        }
    }
};
</script>